import { isAuthenticated, isNotAuthenticated } from './helpers/guards';
import ForgotPassword from './views/ForgotPassword.vue';
import ForgotPasswordConfirm from './views/ForgotPasswordConfirm.vue';
import Login from './views/Login.vue';
import Logout from './views/Logout.vue';
import Register from './views/Register.vue';
import MyAccount from './views/MyAccount.vue';
import MyProfile from './components/account/MyProfile.vue';
import Addresses from './components/account/Addresses.vue';
// import Newsletter from './components/account/Newsletter.vue';
import OrderHistory from './components/account/OrderHistory.vue';
import OrderDetails from './components/account/OrderDetails.vue';
import MyWishlist from './components/account/MyWishlist.vue';
import OrderDetailsPage from './views/OrderDetails.vue';

const routes = [
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    beforeEnter: isNotAuthenticated,
    meta: {
      layout: 'Simple',
    },
  },
  {
    path: '/forgot-password/confirm',
    name: 'ForgotPasswordConfirm',
    component: ForgotPasswordConfirm,
    beforeEnter: isNotAuthenticated,
    meta: {
      layout: 'Simple',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: isNotAuthenticated,
    meta: {
      layout: 'Simple',
    },
  },
  {
    path: '/my-account',
    name: 'MyAccount',
    beforeEnter: isAuthenticated,
    component: MyAccount,
    redirect: '/my-account/my-profile',
    children: [
      {
        path: '/my-account/my-profile',
        name: 'MyProfile',
        component: MyProfile,
        beforeEnter: isAuthenticated,
        meta: {
          name: 'My Profile',
          showInMyAccountMenu: true,
        },
      },
      {
        path: '/my-account/addresses',
        name: 'Addresses',
        component: Addresses,
        beforeEnter: isAuthenticated,
        meta: {
          name: 'My Addresses',
          showInMyAccountMenu: true,
        },
      },
      // {
      //   path: '/my-account/newsletter',
      //   name: 'Newsletter',
      //   component: Newsletter,
      //   beforeEnter: isAuthenticated,
      //   meta: {
      //     name: 'Newsletter',
      //   },
      // },
      {
        path: '/my-account/order-history',
        name: 'OrderHistory',
        component: OrderHistory,
        beforeEnter: isAuthenticated,
        meta: {
          name: 'OrderHistory',
          showInMyAccountMenu: true,
        },
      },
      {
        path: '/my-account/order-history/:id',
        name: 'OrderDetails',
        component: OrderDetails,
        beforeEnter: isAuthenticated,
        meta: {
          name: 'OrderDetails',
        },
      },
      {
        path: '/my-account/shopping-list',
        name: 'MyWishlist',
        component: MyWishlist,
        beforeEnter: isAuthenticated,
        meta: {
          name: 'Shopping List',
          showInMyAccountMenu: true,
        },
      },
    ],
  },
  {
    path: '/orderdetails/:id',
    name: 'OrderDetails',
    component: OrderDetailsPage,
    beforeEnter: isAuthenticated,
    meta: {
      name: 'OrderDetails',
      layout: 'Simple',
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    beforeEnter: isNotAuthenticated,
    meta: {
      layout: 'Simple',
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    beforeEnter: isAuthenticated,
    meta: {
      name: 'Logout',
      layout: 'empty',
    },
  },
];

export default routes;
